import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Grid, Card, CardMedia, CardContent, CardActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import publicEngagementData from '../data/PublicEngagementData.json';

const PublicEngagementDetail = () => {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const item = publicEngagementData.find((entry) => entry.slug === slug);

  if (!item) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4">{t('public_engagement.not_found', 'Page not found')}</Typography>
      </Box>
    );
  }

  const title = language === 'es' ? item.title_es : item.title_en;

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1200, mx: 'auto', minHeight: '80vh' }}>


      <Typography variant="h3" gutterBottom align="center" sx={{ fontSize: { xs: '1.8rem', md: '2.4rem' }, mb: 4 }}>
        {title}
      </Typography>

      {item.layout === 'timeline' ? (
        <Box>
          <Box sx={{ mb: 4, maxWidth: 900, mx: 'auto', textAlign: 'center' }}>
            {(item.items || []).map((entry, index) => (
              <Typography key={`${entry}-${index}`} variant="body1" sx={{ mb: 1.5, lineHeight: 1.7, fontSize: '1rem' }}>
                {entry}
              </Typography>
            ))}
          </Box>

          <Grid container spacing={3} sx={{ mt: 2, justifyContent: 'center' }}>
            {(item.gallery || []).map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={`${image}-${index}`}>
                <Box
                  sx={{
                    height: 240,
                    overflow: 'hidden',
                    borderRadius: 2,
                    boxShadow: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f5f5f5',
                  }}
                >
                  <CardMedia
                    component="img"
                    image={`${process.env.PUBLIC_URL}${image}`}
                    alt={`${title}-gallery-${index + 1}`}
                    sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : (
        <Box>
          <Grid container spacing={3} justifyContent="center">
            {(item.events || []).map((event) => {
              const eventTitle = language === 'es' ? event.title_es : event.title_en;
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  key={event.slug}
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      maxWidth: 350,
                      minWidth: 300,
                      height: 400,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      textAlign: 'center',
                      boxShadow: 3,
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="220"
                      image={`${process.env.PUBLIC_URL}${event.image}`}
                      alt={eventTitle}
                      sx={{ objectFit: 'cover', width: '100%' }}
                    />
                    <CardContent sx={{ flexGrow: 1, px: 2, pt: 2 }}>
                      <Typography
                        variant="subtitle2"
                        color="text.primary"
                        sx={{
                          fontWeight: 'bold',
                          fontSize: '0.95rem',
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 3,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {eventTitle}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ pb: 2, justifyContent: 'center' }}>
                      <Button
                        component={RouterLink}
                        to={`/public-engagement/${item.slug}/${event.slug}`}
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: 'black',
                          '&:hover': { backgroundColor: '#333' },
                          fontSize: '0.875rem',
                        }}
                      >
                        {t('public_input.read_more', 'Read More')}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default PublicEngagementDetail;
